import { z } from 'zod';

export const TEXT_COLOR_VALUES = {
  BLACK: 'BLACK',
  RED: 'RED',
  BLUE: 'BLUE',
  GRAY: 'GRAY',
} as const;
export const templateTextColorSchema = z.enum(TEXT_COLOR_VALUES);
export type TemplateTextColor = z.infer<typeof templateTextColorSchema>;
export const TEXT_COLOR_STYLE = {
  [TEXT_COLOR_VALUES.BLACK]: 'text-black',
  [TEXT_COLOR_VALUES.RED]: 'text-destructive',
  [TEXT_COLOR_VALUES.BLUE]: 'text-blue-700',
  [TEXT_COLOR_VALUES.GRAY]: 'text-muted-foreground',
} as const;
export const TEXT_COLOR_CIRCLE = {
  [TEXT_COLOR_VALUES.BLACK]: 'black',
  [TEXT_COLOR_VALUES.RED]: 'red',
  [TEXT_COLOR_VALUES.BLUE]: 'blue',
  [TEXT_COLOR_VALUES.GRAY]: 'gray',
} as const;

export const FONT_SIZE_VALUES = {
  BASE: '16',
  XL: '20',
  '2XL': '24',
  '3XL': '30',
  '5XL': '48',
  '6XL': '60',
} as const;
export const templateFontSizeSchema = z.enum(FONT_SIZE_VALUES);
export const FONT_SIZE_STYLE = {
  [FONT_SIZE_VALUES.BASE]: 'text-base',
  [FONT_SIZE_VALUES.XL]: 'text-xl',
  [FONT_SIZE_VALUES['2XL']]: 'text-2xl',
  [FONT_SIZE_VALUES['3XL']]: 'text-3xl',
  [FONT_SIZE_VALUES['5XL']]: 'text-5xl',
  [FONT_SIZE_VALUES['6XL']]: 'text-6xl',
} as const;

export const TEXT_FORMAT_VALUES = {
  BOLD: 'bold',
  ITALIC: 'italic',
  UNDERLINE: 'underline',
} as const;
export const templateTextFormatSchema = z.enum(TEXT_FORMAT_VALUES);
export const TEXT_FORMAT_STYLE = {
  [TEXT_FORMAT_VALUES.BOLD]: 'font-semibold',
  [TEXT_FORMAT_VALUES.ITALIC]: 'italic',
  [TEXT_FORMAT_VALUES.UNDERLINE]: 'underline',
} as const;

export const TEXT_ALIGN_VALUES = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
} as const;
export const templateTextAlignSchema = z.enum(TEXT_ALIGN_VALUES);
export const TEXT_ALIGN_STYLE = {
  [TEXT_ALIGN_VALUES.LEFT]: 'justify-start',
  [TEXT_ALIGN_VALUES.CENTER]: 'justify-center',
  [TEXT_ALIGN_VALUES.RIGHT]: 'justify-end',
} as const;

export const TEXT_TYPE_STYLE = {
  DEFAULT: 'default',
  SAME_AS_LABEL: 'same-as-label',
} as const;
export const templateTextStyleSchema = z.enum(TEXT_TYPE_STYLE);
